module.exports = __webpack_public_path__ + "static/media/alchmizer-image-arrows.901d3c87.webp";